// extracted by mini-css-extract-plugin
export default {"image":"SW-z","loaded":"TW-z"};